<script setup lang="ts">
import { ref } from 'vue'

import { useEditorBetaStore } from '@/stores/editor/beta'
import { useModalPresetStore } from '@/stores/modal/presets'

const props = defineProps<{
    insertIndex: number
}>()

const betaStore = useEditorBetaStore()
const presetStore = useModalPresetStore()
const loading = ref(false)

const handleAddSectionFromPreset = async (preset: any) => {
    if (loading.value) return

    loading.value = true

    try {
        await betaStore.addSectionAtIndex(props.insertIndex, preset)
    } catch (error) {
        console.warn(error)
    } finally {
        loading.value = false
    }
}

const onAddSection = () => {
    if (loading.value) return

    presetStore.setAction((preset: any) => handleAddSectionFromPreset(preset))
    presetStore.setIsOpenModal(true)
}
</script>

<template>
    <div class="editor-beta-section-divider">
        <div class="editor-beta-section-divider__line" />

        <button
            type="button"
            class="editor-beta-section-divider__button"
            :disabled="loading"
            @click="onAddSection"
        >
            <span class="sr-only">Adicionar seção</span>
            <svg viewBox="0 0 24 24" fill="none" class="editor-beta-section-divider__icon">
                <path d="M12 7.19995V16.8M16.8 12H7.2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
            </svg>
        </button>
    </div>
</template>

<style scoped>
.editor-beta-section-divider {
    @apply relative flex h-8 items-center justify-center;
}

.editor-beta-section-divider__line {
    @apply absolute inset-x-0 top-1/2 h-px -translate-y-1/2 bg-[rgba(185,199,220,0.42)];
}

.editor-beta-section-divider__button {
    @apply relative z-10 flex h-7 w-7 items-center justify-center rounded-full border border-[#E8EDF6] bg-white text-[#61728A] shadow-[0_6px_14px_rgba(15,23,42,0.06)] transition-all duration-200 hover:-translate-y-0.5 hover:border-[#D3DDEB] hover:text-[#21344F] disabled:cursor-not-allowed disabled:opacity-70;
}

.editor-beta-section-divider__icon {
    @apply h-3.5 w-3.5;
}
</style>
